// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const server_api_root_config = {
  PAYEX_INT: 'http://15.207.53.212:8099',
  PAYEX_DEV: 'http://13.232.240.12:8099',
  PAYEX_UAT: 'https://uat.payex.live',
  PAYEX_QA: 'https://qa.payex.live',
  //  PAYEX_QA: 'https://axisqa.payex.live',
  PAYEX_DEMO: 'https://demo.payex.live',
  PAYEX_PROD: 'https://prod.payex.live',
  PAYEX_NEW_UAT: 'https://rearchuat.payex.live',
  PAYEX_LANG: 'https://demo.payex.live/PayEXDCAPI/static',
  PAYEX_NODE_API: 'https://qa.payex.live/PayEXDCAPI/',
  PAYEX_FIS_UAT: 'https://fisuat.payex.live'
};

const web_api_root_config = { 
  PAYEX_INT: server_api_root_config.PAYEX_INT,
  PAYEX_DEV: server_api_root_config.PAYEX_DEV,
  PAYEX_UAT: `${server_api_root_config.PAYEX_UAT}/eipp`,
  PAYEX_QA: `${server_api_root_config.PAYEX_QA}/eipp`,
  PAYEX_FIS_UAT: `${server_api_root_config.PAYEX_FIS_UAT}/eipp`,
  PAYEX_DEMO: `${server_api_root_config.PAYEX_DEMO}/eipp`,
  PAYEX_PROD: `${server_api_root_config.PAYEX_PROD}/eipp`,
  PAYEX_NEW_UAT: `${server_api_root_config.PAYEX_NEW_UAT}/eipp`,
};

const environmentConfig = window['overrideEnvironment'] || {};
const environmentAPIDefined = (window['overrideEnvironment'] && window['overrideEnvironment'].API);
const app_deploy_environment = environmentAPIDefined ? environmentAPIDefined : 'PAYEX_DEMO';
const web_api_version = '';
const web_api_root = environmentAPIDefined ? environmentAPIDefined : web_api_root_config[app_deploy_environment];
const langAssetsUrl = environmentConfig.LANG_ASSETS_BASE_URL || `${server_api_root_config['QA']}/PayEXDCAPI/static/lang-assets/`;
const nodeAPIUrl = (window['overrideEnvironment'] && window['overrideEnvironment'].PAYEX_NODE_API) ?
  (window['overrideEnvironment'] && window['overrideEnvironment'].PAYEX_NODE_API) :
  `${server_api_root_config['PAYEX_NODE_API']}`;


export const environment = {
  production: false,
  getRoot: web_api_root,
  base: web_api_root,
  API: {
    'Freepay': {
      url: `${web_api_root}/${web_api_version}`
    },
    'FreepaySM': {
      url: `${web_api_root}/PayexSMApi_v38`
    },
    'OfflineInsurance': {
      url: `${web_api_root}/PayexApi_${web_api_version}`
    }
  },
  environment_name: app_deploy_environment,
  web_api_version: web_api_version,
  langAssetsUrl,
  nodeAPIUrl,
  appName: 'Freepay',
  environmentConfig
};
